/**
 * Teams Component - Created by cazarez on 07/02/18.
 */
import * as React from 'react'
import { Container, Title, Text } from './styledComponents'
import messages from './messages'
import Span from '../Common/UnderlinedLink'
import ColorChart from '../ColorChart'
import ColorChartForm from '../ColorChartForm'
import { UserInfo } from '../../types/common'

interface Props {
  title?: string
  links?: any[]
  isMobile?: boolean
  history?: any
  availableLinks?: any
  colorChartSending?: boolean
  colorChartModalOpen?: boolean
  colorChartModalFormOpen?: boolean
  onCloseColorChart?: () => void
  onOpenColorChart?: () => void
  onOpenFormChart?: () => void
  onCloseColorChartForm?: () => void
  onRequestColorChart?: (userInfo: UserInfo) => void
  formatMessage: (messageDescriptor: any) => string
}

const Teams = ({ 
  formatMessage, 
  history, 
  title = '', 
  links = [], 
  availableLinks,
  colorChartSending,
  colorChartModalOpen,
  colorChartModalFormOpen,
  onCloseColorChart,
  onOpenColorChart,
  onOpenFormChart,
  onCloseColorChartForm,
  onRequestColorChart
}: Props) => {
  const callBack = (route: string) => {
    if (route === '/color-chart' && onOpenColorChart) {
      onOpenColorChart()
    }
  }
  return (
    <Container>
      <Title>{title || formatMessage(messages.quickLinks)}</Title>
      {links.map(({ name, route, withAction, dynamic }, key: number) => dynamic && !availableLinks.has(route) ? null : (
        <Text {...{ key }}>
          <Span {...{ history, callBack, withAction }} link={`/${route}`} >
            {name}
          </Span>
        </Text>
      ))}
      {colorChartModalOpen &&
        <ColorChart
          {...{ formatMessage }}
          open={colorChartModalOpen}
          handleClose={onCloseColorChart}
          handleOpenForm={onOpenFormChart}
        />
      }
      {colorChartModalFormOpen &&
        <ColorChartForm
          open={colorChartModalFormOpen}
          handleClose={onCloseColorChartForm}
          formatMessage={formatMessage}
          loading={colorChartSending}
          {...{ onRequestColorChart }}
        />
      }
    </Container>
  )
}

export default Teams



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/FooterLinks/index.tsx